/**
 * Convex API stubs — function names must match RSAConvex/convex/.
 */
import { makeFunctionReference } from 'convex/server';

export const api = {
  services: {
    getServiceLocation: makeFunctionReference('services:getServiceLocation'),
    getServicePolyline: makeFunctionReference('services:getServicePolyline'),
    listVendorNotifications: makeFunctionReference('services:listVendorNotifications'),
    acknowledgeVendorNotifications: makeFunctionReference('services:acknowledgeVendorNotifications'),
  },
};
